
( ( $ ) => {

	// Recalculate the position of the sticky menu
	phr_reposition_sticky_menu = () => {

		var header_bar_height		= $( '.header-components' ).outerHeight();
		var notification_bar_height	= $( '.site-wide-notification' ).outerHeight();
		var content_total_distance	= parseInt( notification_bar_height + header_bar_height );

		if ( isNaN( content_total_distance ) )
		{
			content_total_distance	= parseInt( header_bar_height );
		}

		// Content
		$( '.site-main' ).css({
			'margin-top': content_total_distance + 'px',
		});

		if ( $( '#wpadminbar' ).length > 0 )
		{
			var admin_bar_height = $( '#wpadminbar' ).outerHeight();

			if ( $( '#wp-admin-bar-wp-logo' ).is( ':hidden' ) )
			{
				if ( $( document ).scrollTop() >= admin_bar_height )
				{
					$( '.site-header' ).addClass( 'fixed-top' ).prop( 'style', 'top: 0px !important' );

					// Content
					$( '.site-main' ).css({
						'margin-top': content_total_distance + 'px',
					});
				}
				else
				{
					$( '.site-header' ).removeClass( 'fixed-top' ).removeAttr( 'style' );

					// Content
					$( '.site-main' ).removeAttr( 'style' );
				}

				// Adjust the burger menu position in case we're on mobile
				// and the admin bar is showing
				content_total_distance += admin_bar_height;

				var admin_bar_position = parseInt( $( "#wpadminbar" ).offset().top - $( document ).scrollTop() );    
	
				if ( admin_bar_position <= 0 && admin_bar_position >= -( admin_bar_height ) )
				{
					content_total_distance += admin_bar_position;
				}
				else
				{
					content_total_distance = parseInt( notification_bar_height + header_bar_height );
				}

				// Burger menu bottom adjust
				$( '.burger-menu-wrapper' ).removeProp( 'style' ).prop( 'style', 'top: ' + content_total_distance + 'px;' );

				return;
			}
			else
			{
				$( '.site-header' ).prop( 'style', 'top: ' + admin_bar_height + 'px !important' );
				$( '.site-header' ).addClass( 'fixed-top' );
			}

			content_total_distance += admin_bar_height;

			// Burger menu bottom adjust
			$( '.burger-menu-wrapper' ).removeProp( 'style' ).prop( 'style', 'top: ' + content_total_distance + 'px;' );

			return;
		}

		// Burger menu bottom adjust
		$( '.burger-menu-wrapper' ).removeProp( 'style' ).prop( 'style', 'top: ' + content_total_distance + 'px;' );
	}

	phr_reposition_sticky_menu();
	$( window ).on( 'resize', phr_reposition_sticky_menu );
	$( window ).on( 'scroll', phr_reposition_sticky_menu );

} )( jQuery );
